//* Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';

//* Base
import { DashboardComponent } from '@dashboard/dashboard.component';
import { DashboardRoutingModule } from '@dashboard/dashboard-routing.module';
import { DashboardService } from '@dashboard/dashboard.service';
import * as children from '@dashboard/components';

//* Third Party
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { HighchartsChartModule } from 'highcharts-angular';

//* Components
const components = [DashboardComponent, ...children.components];

//* Modules
const modules = [
  CommonModule,
  DashboardRoutingModule,
  SharedModule,
  AccordionModule,
  HighchartsChartModule,
];

//* Services
const services = [DashboardService];

const dashboard = {
  components,
  modules,
  services,
};

@NgModule({
  declarations: dashboard.components,
  imports: dashboard.modules,
  exports: dashboard.components,
  providers: dashboard.services,
})
export class DashboardModule {}
